import Service from "../Service";

const resource = "/hmnassignbusperson/";

export default {

    save(obj, requestID) {
        console.log(obj);
        
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },

    exportToExcel(filter, requestID) {
        return Service.post(resource + "exporttoexcel", filter, {
            params: { requestID: requestID },
        });
    }
};